import { render, staticRenderFns } from "./AppTable.vue?vue&type=template&id=1901a224&scoped=true"
import script from "./AppTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppTable.vue?vue&type=style&index=0&id=1901a224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901a224",
  null
  
)

export default component.exports